<div class="finance-options">
	<!--  STEP HEADER  -->

	<cng-step-header
		[current_step_key]="current_step_key"
		[location]="'engage_configure'"
		(jump)="jumpTo($event)"
	></cng-step-header>

	<!--  END STEP HEADER  -->

	<!--  CONTAINER  -->

	<div *ngIf="!cashback_deal" class="container">
		<!--  HEADING  -->

		<div class="heading">
			<ui-concierge
				data-element-view="concierge__engage_configure_payment_options_step__[How would you like to pay for the vehicle?]"
			>
				<h1>How would you like to pay for the vehicle?</h1>
				<p class="hidden-xxs hidden-xs">
					Select whether you would like to pay using finance or a cash payment, if you're buying your vehicle
					outright.
				</p>
				<p class="hidden-xxs hidden-xs margin-top-0">
					Our finance partners offer competitive quotes for all circumstances.
				</p>
				<p class="hidden-xxs hidden-xs margin-top-0">You can change your payment options at any time.</p>
			</ui-concierge>
		</div>

		<!--  END HEADING  -->

		<!-- FINANCE FORM  -->

		<cng-finance-form></cng-finance-form>

		<!-- END FINANCE FORM  -->
	</div>

	<!-- END CONTAINER  -->

	<!--  NO FINANCE CONTAINER  -->

	<div *ngIf="cashback_deal" class="container">
		<!--  HEADING  -->

		<div class="heading">
			<ui-concierge data-element-view="concierge__engage_configure_payment_options_step__[Cashback Deal]">
				<h1>Cashback Deal</h1>
				<p>Due to the valuation on your part exchange, finance is no longer available on this deal.</p>
			</ui-concierge>
		</div>

		<!--  END HEADING  -->
	</div>

	<!-- END NO FINANCE CONTAINER  -->

	<!--  TOTAL BAR  -->

	<cng-fixed-footer></cng-fixed-footer>

	<!--  END TOTAL BAR  -->

	<!--  STEP BAR  -->

	<cng-step-bar
		[current_step_key]="current_step_key"
		[show_next]="hasFollowingSteps()"
		(jump)="jumpTo($event)"
	></cng-step-bar>

	<!--  END STEP BAR  -->

	<!--  SCROLL FADES  -->

	<div class="scroll-fade top"></div>
	<div class="scroll-fade bottom"></div>

	<!-- END SCROLL FADES  -->
</div>
